const appPaths = {
  root: '/',
  dashboard:'/dashboard'
};

export default appPaths;
